import React from "react";
import { PropLabel } from "../PropX";
import { SkeletonMask } from "../__Internal__";
import { BaseSelectMenu } from "./BaseSelectMenu";

type Props = {
  name: string;
  label?: PropLabel;
  compact?: boolean;
  required?: boolean;
};

const noop = () => {
  /* nothing */
};

export const BaseSelectMenuSkeleton: React.FC<Props> = (props) => {
  const { name, label, compact, required } = props;

  const options = React.useMemo(
    () => [
      {
        value: "nothing",
        title: <SkeletonMask />,
        disabled: false,
      },
    ],
    []
  );

  return (
    <BaseSelectMenu
      name={name}
      label={label}
      compact={compact}
      required={required}
      options={options}
      selected="nothing"
      disabled
      onSelect={noop}
    />
  );
};
